import React, { useContext, useState } from "react";

const TeacherContext = React.createContext();
const SetTeacherContext = React.createContext();

export function useTeacher() {
  return useContext(TeacherContext);
}

export function useSetTeacher() {
  return useContext(SetTeacherContext);
}

export function TeacherProvider({ children }) {
  const [teacher, setTeacher] = useState({ name: "" });

  return (
    <TeacherContext.Provider value={teacher}>
      <SetTeacherContext.Provider value={setTeacher}>
        {children}
      </SetTeacherContext.Provider>
    </TeacherContext.Provider>
  );
}
